import React, { useCallback } from 'react';

import styles from './DataTablePagingPage.module.scss';
import { classnames } from '@src/utils/classnames';
import { Button } from '@src/atoms/Button';
import { Text } from '@src/atoms/Text';

interface IProps {
  currentPage: number;
  onPageChange: (page: number) => void;
  isActive: boolean;
}

export const DataTablePagingPage = ({ currentPage, onPageChange, isActive }: IProps) => {
  const rootClass = classnames(styles.root, isActive && styles.active);

  const handleClick = useCallback(() => {
    onPageChange(currentPage);
  }, [onPageChange, currentPage]);

  return (
    <Button
      id={`paginationButton_${currentPage}`}
      onClick={handleClick}
      view="textLight"
      className={rootClass}
      size="sm"
    >
      <Text id={`paginationButtonText_${currentPage}`}>{currentPage}</Text>
    </Button>
  );
};
